module.exports = CKEDITOR;


//////////////////
// WEBPACK FOOTER
// external "CKEDITOR"
// module id = 1550
// module chunks = 0